import { Component } from '@angular/core';
import { environment } from '@environments/environment';
import { AuthFacade } from '@app/core/store/facade/auth.facade';
import { Credentials } from '@app/auth/components/mobile-auth/mobile-auth.component';
import { NetworkService } from '@app/shared/services/network.service';
import { BehaviorSubject } from 'rxjs';
import { tap } from 'rxjs/operators';

@Component({
  selector: 'app-auth',
  templateUrl: './auth.component.html',
  styleUrls: ['./auth.component.scss'],
})
export class AuthComponent {
  userList = environment.userList;
  loginError: string | undefined;
  private readonly offlineModalDisplay = new BehaviorSubject<boolean>(true);
  readonly offlineModalDisplay$ = this.offlineModalDisplay.asObservable();

  isOnlineMode$ = this.networkService.isOnlineMode$.pipe(
    tap((data) => this.toggleOfflineModal(!data))
  );

  constructor(private authFacade: AuthFacade, private networkService: NetworkService) {}

  mobileLoggingIn({ login, password }: Credentials): void {
    this.authFacade.loginWithCredentials(login, password);
  }

  toggleOfflineModal(display: boolean): void {
    this.offlineModalDisplay.next(display);
  }

  displayModal(): void {
    this.toggleOfflineModal(true);
  }

  onClose(): void {
    this.toggleOfflineModal(false);
  }
}
